export default "<p>\r\n  diocese-collection works!\r\n</p>\r\n"